module.exports = {"data":[{"support_pin":"19920010","user_id":"jqev58x8","category1":{"data":{"id":12,"name":"Choice_0001"}},"category2":{"data":{"id":14,"name":"UX"}},"category3":null,"category4":null,"count_stress_tests":10,"count_appointments":12},{"support_pin":"44992910","user_id":"rxrn73mo","category1":{"data":{"id":13,"name":"Choice_0002"}},"category2":{"data":{"id":15,"name":"Developer"}},"category3":null,"category4":null,"count_stress_tests":2,"count_appointments":8}],"meta":{"pagination":{"count":2,"current_page":1,"per_page":10,"total":2,"total_pages":1}}}


//////////////////
// WEBPACK FOOTER
// ./src/_mockup/individual_user_1.json
// module id = 1881
// module chunks = 0